import React from 'react';
import { useSEOTableConfig } from './useSEOTableConfig';
import { BodyContainer, RowContainer } from './Body.styles';
import Cell from './Cell';

const Body = (): JSX.Element => {
  const { getTemplateColumnsSet, table, firstColumnCustomWidth, columnCount } = useSEOTableConfig();
  const templateColumns = getTemplateColumnsSet(firstColumnCustomWidth, columnCount);

  return (
    <BodyContainer>
      {table.map((row, index) => (
        <RowContainer
          key={index}
          templateColumns={templateColumns}
          columnCount={columnCount}
        >
          <Cell
            text={row.title}
            rowIndex={index}
            anchorTo={row.anchorTo}
            isTitle
          />
          {row.columns.map((column, columnIndex) => (
            <Cell
              key={`${index}-${columnIndex}`}
              entries={column}
              rowIndex={index}
            />
          ))}
        </RowContainer>
      ))}
    </BodyContainer>
  );
};

export default Body;
